import { X } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { hasAnyConsent, initTrackingScripts, setCookieConsent } from '@/lib/cookieConsent'

export const CookieConsent: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false)
  const location = useLocation()

  useEffect(() => {
    // Check if user has already given consent
    if (!hasAnyConsent()) {
      setShowBanner(true)
    } else {
      // Initialize tracking scripts if consent was already given
      initTrackingScripts()
    }
  }, [])

  const handleUnderstand = () => {
    // Accept all cookies when user clicks "I understand"
    const newPreferences = { analytics: true, marketing: true }
    setCookieConsent(newPreferences)
    setShowBanner(false)
    initTrackingScripts()
  }

  // Check if we're on an office page (English) or regular page (Hebrew)
  const isOfficePage = location.pathname.startsWith('/office') || location.pathname.startsWith('/all-packages-view')
  const isRTL = !isOfficePage

  if (!showBanner) {
    return null
  }

  return (
    <div
      className='fixed start-0 end-0 bottom-0 z-50 border-t border-gray-200 bg-white p-4 shadow-lg md:p-6'
      dir={isRTL ? 'rtl' : 'ltr'}
      style={{ direction: isRTL ? 'rtl' : 'ltr' }}
    >
      <div className='relative container mx-auto max-w-6xl'>
        <Button
          onClick={handleUnderstand}
          className='absolute end-0 -top-2 size-8'
          aria-label={isRTL ? 'סגור' : 'Close'}
          type='button'
          variant='ghost'
          size='icon'
        >
          <X className='h-5 w-5' />
        </Button>
        <div className='flex flex-col items-start gap-4 md:flex-row md:items-end'>
          <div className='flex-1'>
            <h3 className='mb-2 text-lg font-semibold'>{isRTL ? 'שימוש בעוגיות' : 'Cookie Usage'}</h3>
            <p className='mb-0 text-sm text-gray-700'>
              {isRTL
                ? 'אנו משתמשים בעוגיות כדי לשפר את חווית הגלישה שלכם. חלק מהעוגיות חיוניות לתפעול האתר, ואחרות עוזרות לנו להבין כיצד אתם משתמשים באתר.'
                : 'We use cookies to improve your browsing experience. Some cookies are essential for the website to function, while others help us understand how you use the site.'}
            </p>
            <p className='mt-2 mb-0 text-xs text-gray-600'>
              {isRTL ? (
                <>
                  למידע נוסף, עיינו ב{' '}
                  <a href='/privacy' className='text-blue-600 underline hover:text-blue-800'>
                    מדיניות הפרטיות
                  </a>{' '}
                  שלנו.
                </>
              ) : (
                <>
                  For more information, please see our{' '}
                  <a href='/privacy' className='text-blue-600 underline hover:text-blue-800'>
                    Privacy Policy
                  </a>
                  .
                </>
              )}
            </p>
          </div>
          <div className='flex w-full md:w-auto'>
            <Button variant='default' size='sm' onClick={handleUnderstand} className='whitespace-nowrap'>
              {isRTL ? 'הבנתי' : 'I understand'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
